export default __webpack_public_path__ + "static/mobile_KV11-a7d4815c18c560c050e73b754f72c827.mp4";